import { createEvent, createStore } from 'effector';

export const setOpenedId = createEvent<number | string>();
export const $openedId = createStore<number | string | null>(null);
